import React from "react";
import { Button } from "../../common";
import appRoutes from "../../../routes/app.routes";
import ArrowUp from "../icons/arrow-up.svg";
import { NavLink } from "react-router-dom";
import FeedList from "../../../pages/Feeds/FeedList";

interface FeedsProps {
  isPublicPage?: boolean;
  feeds?: any[];
  headerUser?: {
    name?: string;
    profile_image?: string;
    isCompany?: boolean;
  };
}

function Feeds({ isPublicPage, feeds, headerUser }: FeedsProps) {
  const publicFeeds = Array.isArray(feeds) ? feeds : [];
  return (
    <>
      <div className="posts-wrapper">
        {isPublicPage ? (
          <FeedList
            pageSize={3}
            fetchOnScroll={false}
            readOnly={true}
            feeds={publicFeeds}
            headerUser={headerUser}
          />
        ) : (
          <FeedList
            myPosts="my-posts"
            pageSize={3}
            fetchOnScroll={false}
            readOnly={isPublicPage}
          />
        )}
        {
          !isPublicPage && (
            <div className="btn-wrapper">
              <NavLink to={(appRoutes as any).home.path}>
                <Button className="all-services-btn" variant="contained">
                  <span>See more</span>
                  <img src={ArrowUp} alt="Arrow" />
                </Button>
              </NavLink>
            </div>
          )
        }
      </div>
    </>
  );
}

export default Feeds;
